<div>
  <div class="title-bar">
    <h1 class="mt-5">Piactér</h1>
  </div>
  <mat-card class="search-input-container my-0 d-flex justify-content-center">
    <app-search-input></app-search-input>
  </mat-card>

  <ng-container *ngIf="(resultIsLoading$ | async) === false">
    <p class="mb-4 mt-3">{{ (totalSearchedItems$ | async) + " találat" }}</p>
    <div
      *ngIf="totalSearchedItems$ | async; else noResult"
      class="result-container"
      [ngClass]="{ 'is-sidenav-opened': (isSidenavOpen$ | async) === true }"
    >
      <app-search-result-card
        *ngFor="
          let resultElement of searchedItems$ | async;
          trackBy: trackResult
        "
        [data]="resultElement"
        [isSortiment]="!!(isSortiment$ | async)"
      ></app-search-result-card>
    </div>
    <ng-template #noResult>
      <div
        class="spinner-container"
        *ngIf="
          (requiredMerchantDataFilled$ | async) === true;
          else forbiddenSearchMsg
        "
      >
        {{ "SEARCH.NO_SEARCH_RESULT_FOUND" | translate }}
      </div>
    </ng-template>
    <ng-template #forbiddenSearchMsg>
      <div class="spinner-container">
        {{ "ERROR_CODE.NO_VALID_MERCHANT_TYPE" | translate }}
      </div>
    </ng-template>
  </ng-container>
</div>
<mat-paginator
  class="paginator"
  [length]="(totalSearchedItems$ | async) ?? 0"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="pageChanged($event)"
  showFirstLastButtons
></mat-paginator>
